var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./flexboxItem.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c96d5ee8\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./flexboxItem.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/muse-ui/src/flexbox/flexboxItem.vue
// module id = 660
// module chunks = 1